export default __webpack_public_path__ + "static/media/no-hardware-image.90427718.svg";